define('views/content/reports/country_sales',['require','backbone','marionette','bootstrap-daterangepicker','datatables','text!templates/content/reports/country_sales.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('datatables');

    var temp = require("text!templates/content/reports/country_sales.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'country_sales',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                countrySalesTable: '.country-sales-list'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.getReports();
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));

                this.getReports();
            } else {
                this.ui.reportDateRangeTabs.find('li[data-range="day"]').click();
            }

        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'last_30_days') {
                    var monthAgo = new Date(tomorrow.getTime());
                    monthAgo.setDate(monthAgo.getDate() - 30);

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthAgo);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.getReports();
            }
        },

        getReports: function () {
            var _this = this;

            // Save date parameters in local storage
            localStorage.setItem('report_start_time', this.ui.reportDateRangePicker.data('daterangepicker').startDate.toDate().getTime());
            localStorage.setItem('report_end_time', this.ui.reportDateRangePicker.data('daterangepicker').endDate.toDate().getTime());

            $.ajax({
                url: App.Config.apiBase + 'reports/country-sales-reports/',
                method: 'get',
                data: {
                    start_date: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD')
                },
                success: function (response) {
                    _this.showCountrySaleReports(response.country_report);
                }
            });
        },

        showCountrySaleReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [];

            var totalRow = {
                local_count: 0,
                foreign_count: 0,
                total_count: 0,
                local_price: 0,
                foreign_price: 0,
                total_price: 0
            };

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    reportRow.local_count,
                    reportRow.foreign_count,
                    reportRow.total_count,
                    (reportRow.local_price.toFixed(2) + ' $'),
                    (reportRow.foreign_price.toFixed(2) + ' $'),
                    (reportRow.total_price.toFixed(2) + ' $'),
                    (reportRow.local_price > 0 ?
                        ((reportRow.local_price / reportRow.total_price) * 100).toFixed(2) : 0) + ' %',
                    (reportRow.foreign_price > 0 ?
                        ((reportRow.foreign_price / reportRow.total_price) * 100).toFixed(2): 0) + ' %'
                ]);

                totalRow.local_count += reportRow.local_count;
                totalRow.foreign_count += reportRow.foreign_count;
                totalRow.total_count += reportRow.total_count;
                totalRow.local_price += reportRow.local_price;
                totalRow.foreign_price += reportRow.foreign_price;
                totalRow.total_price += reportRow.total_price;
            });

            // Add total row
            gridData.push([
                App.polyglot.t('total'),
                totalRow.local_count,
                totalRow.foreign_count,
                totalRow.total_count,
                (totalRow.local_price.toFixed(2) + ' $'),
                (totalRow.foreign_price.toFixed(2) + ' $'),
                (totalRow.total_price.toFixed(2) + ' $'),
                '',
                ''
            ]);

            if (!this.countrySalesDataTable) {
                this.countrySalesDataTable = this.ui.countrySalesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('local_sales'), className: 'text-right' },
                        { title: App.polyglot.t('foreign_sales'), className: 'text-right' },
                        { title: App.polyglot.t('total_sales'), className: 'text-right' },
                        { title: App.polyglot.t('local_gross'), className: 'text-right' },
                        { title: App.polyglot.t('foreign_gross'), className: 'text-right' },
                        { title: App.polyglot.t('total_gross'), className: 'text-right' },
                        { title: App.polyglot.t('local_ratio'), className: 'text-right' },
                        { title: App.polyglot.t('foreign_ratio'), className: 'text-right' }
                    ]
                });
            } else {
                this.countrySalesDataTable.clear();
                this.countrySalesDataTable.rows.add(gridData);
                this.countrySalesDataTable.columns.adjust().draw();
            }
        }

    });
});
